import { chargesCalculationV1 } from "@helpers/customCardHelper";
import { formatCurrencyINR } from "@utils/numberFormatter";
import { getRIPPlusConsumer } from "@helpers/carFinanceCalculations";

export function getSellableDetails(
  res: any,
  data: any,
  isLoggedIn: boolean,
  city: any
) {
  const variant = (res?.variants || []).find(
    (variant: any) => variant?.slug === data?.slug
  );

  return {
    charges: chargesCalculationV1(res),
    discounts: [
      {
        label: `On-road price in ${city?.name}`,
        value:
          formatCurrencyINR(
            Number(res?.price?.market_price) -
              Number(getRIPPlusConsumer(res?.price?.savings_breakup))
          ) || "",
      },
      {
        label: "ACKO Drive discount",
        value: isLoggedIn
          ? `-${formatCurrencyINR(res?.price?.savings_breakup?.ackodiscount)}`
          : `₹${res?.price?.savings_breakup?.ackodiscount}`,
      },
    ],
    consumerSavings:
      res?.price?.savings_breakup?.consumerdiscount > 0
        ? formatCurrencyINR(getRIPPlusConsumer(res?.price?.savings_breakup))
        : undefined,
    finalPrice: isLoggedIn
      ? formatCurrencyINR(res?.price?.adsp_price)
      : `₹${res?.price?.adsp_price}`,
    isExpressDelivery: variant?.tags?.is_express_delivery || false,
    deliveryDate: variant?.waiting_period || "",
  };
}

export function getNonSellableDetails(res: any, city: any) {
  return {
    charges: chargesCalculationV1(res),
    discounts: [
      {
        label: `On-road price in ${city?.name}`,
        value:
          formatCurrencyINR(
            Number(res?.price?.market_price) -
              Number(getRIPPlusConsumer(res?.price?.savings_breakup))
          ) || "",
      },
    ],
    consumerSavings:
      res?.price?.savings_breakup?.consumerdiscount > 0
        ? formatCurrencyINR(getRIPPlusConsumer(res?.price?.savings_breakup))
        : undefined,
    finalPrice: formatCurrencyINR(res?.price?.adsp_price),
    isExpressDelivery: false,
    deliveryDate: "",
  };
}
